import * as ActionTypes from './auth.actionTypes';

const initialState = {
  isAuthenticated: false,
  isLoading: true,
  ulrAfterLogin: null,
  authToken: null,
  user: null,
  role: null,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.AUTH_INVALIDATE:
      return {
        ...state,
        isAuthenticated: false,
        isLoading: false,
        authToken: null,
        user: null,
        role: null,
        acl: null,
      };

    case ActionTypes.LOGIN_REQUEST:
      return {
        ...state,
        isAuthenticated: false,
        isLoading: false,
      };

    case ActionTypes.LOGIN_REQUEST_TOKEN:
      return {
        ...state,
        isAuthenticated: false,
        isLoading: true,
      };

    case ActionTypes.LOGIN_SUCCESS:
      let user = null;
      let token = null;
      let role = null;
      if (action.response) {
        user = action.response.result.user;
        token = action.response.result.token;
        role = action.response.entities.user[user.id].role;
      } else if (action.payload && action.payload.result) {
        user = action.payload.result.user;
        token = action.payload.result.token;
        role = action.payload.entities.user[user.id].role;
      }
      localStorage.setItem('wihuri-mia-token', token);
      return {
        ...state,
        isLoading: false,
        isAuthenticated: true,
        authToken: token,
        user: user.id,
        role,
      };

    case ActionTypes.LOGIN_FAILURE:
      localStorage.removeItem('wihuri-mia-token');
      return {
        ...state,
        isLoading: false,
        isAuthenticated: false,
        authToken: null,
        user: null,
        role: null,
      };

    case ActionTypes.LOGOUT_REQUEST:
      return {
        ...state,
      };

    case ActionTypes.LOGOUT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isAuthenticated: false,
        ulrAfterLogin: null,
        authToken: null,
        user: null,
        role: null,
      };

    case ActionTypes.LOGOUT_FAILURE:
      return {
        ...state,
        isLoading: false,
      };

    case ActionTypes.URL_AFTER_LOGIN:
      const url = action.url;
      return {
        ...state,
        ulrAfterLogin: url,
      };

    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/modules/auth/auth.reducer.js